<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="200"
      size="mini"
      resizable
      border
      ref="contrinerTable"
      :mouse-config="{ selected: true }"
      :edit-config="{
        trigger: 'click',
        mode: 'cell',
        activeMethod: activeCellMethod,
      }"
      :edit-rules="validRules"
      @edit-closed="editClosed"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          type: 'seq',
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
        },
        {
          title: this.$l('INDEX.form_label_editContainerNo') || '编辑柜号',
          field: 'editContainerNo',
          width: 170,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_label_containerNo') || '集装箱号',
          field: 'containerNo',
          minWidth: 150,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          editRender: {
            name: 'ElInput',
            props: {
              placeholder:
                this.$l('INDEX.form_placeholder_containerNo') ||
                '请输入集装箱号',
              clearable: true,
            },
          },
        },
        {
          title: this.$l('INDEX.form_label_sealNo') || '箱封号',
          field: 'sealNo',
          minWidth: 150,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          editRender: {
            name: 'ElInput',
            props: {
              placeholder:
                this.$l('INDEX.form_placeholder_sealNo') || '请输入箱封号',
              clearable: true,
            },
          },
        },
        {
          title: this.$l('INDEX.form_containerWeight') || '集装箱皮重(KG)',
          field: 'containerWeight',
          width: 150,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          editRender: {
            name: 'ElInputNumber',
            props: {
              placeholder:
                this.$l('INDEX.form_placeholder_containerWeight') ||
                '请输入集装箱皮重',
              clearable: true,
              controlsPosition: 'right',
              style: 'width:100%',
              min: 0,
              step: 0.01,
              precision: 4,
            },
          },
        },
      ],
      validRules: {
        containerNo: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_containerNo') || '请输入集装箱号',
          },
        ],
        sealNo: [
          {
            required: true,
            message: this.$l('INDEX.form_placeholder_sealNo') || '请输入箱封号',
          },
        ],
        containerWeight: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_containerWeight') || '请输入集装箱皮重',
          },
        ],
      },
    }
  },
  methods: {
    getTableData() {
      const { fullData } = this.$refs.contrinerTable.getTableData() || {}
      return fullData
    },
    async validate() {
      const result = await this.$refs.contrinerTable.validate(true)
      return !result
    },
    activeCellMethod() {
      return !this.disabled
    },
    editClosed(e) {
      console.log('container editClosed >>', e)
    },
  },
}
</script>
